// utils/resetSession.js
export const resetSession = () => {
  // localStorage
  localStorage.removeItem("allocationId");
  localStorage.removeItem("tableSession");
  localStorage.removeItem("guestInfo");
  localStorage.removeItem("qrSession");

  // sessionStorage
  sessionStorage.removeItem("cartValue");
  sessionStorage.removeItem("cartQuantityValue");
  sessionStorage.removeItem("cartTotalValue");
};
